<template>
  <div>
    <a-list itemLayout="vertical">
      <a-list-item v-if="record">
        <div slot="actions">
          <a-button type="link" icon="eye" @click="viewResume"
            >查看简历附件</a-button
          >
          <!-- <a-button type="link" icon="file-word" @click="viewReport">简历报告</a-button> -->
          <a-button type="link" icon="download" @click="downloadResume" v-if="user.uid === '1' || user.uid === '3' || user.uid === '5'">下载简历附件</a-button>
        </div>
        <a-row type="flex">
          <a-col span="24">
            <h2>候选人基本信息</h2>
          </a-col>
          <a-col span="7">
            <h4>姓名：{{ record.name }}</h4>
          </a-col>
          <a-col span="17">
            <h4>公司：{{ record.last_company }}</h4>
          </a-col>
          <a-col span="7">
            <h4>地点：{{ record.city_name }}</h4>
          </a-col>
          <a-col span="17">
            <h4>
              职能：{{
                record.first_category_name + "-" + record.second_category_name
              }}
            </h4>
          </a-col>
        </a-row>
        <div slot="extra" style="padding-right:50px">
          <h4>简历来源：{{ record.source }}</h4>
          <h4>上传人：{{ record.user_name }}</h4>
          <h4>上传时间：{{ record.created_at }}</h4>
        </div>
      </a-list-item>
    </a-list>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Api from "@/api";

export default {
  name: "ResumeDetailList",
  props: ["record"],
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASEURL,
    };
  },
  computed: {
    ...mapState([ 'user' ])
  },
  created() {},
  methods: {
    viewReport() {
      this.$emit("view");
    },
    viewResume() {
      this.$emit("viewResume");
    },
    downloadResume() {
      let attachment = this.record.attachment;
      if (!attachment.preview_url && !attachment.id) {
        this.$message.info("暂无附件");
        return;
      }
      var a = document.createElement("a");
      a.href = this.baseUrl + '/resume/downloadAttachment?attachment_id=' + attachment.id ;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
  }
};
</script>

<style scoped lang="scss"></style>
